import React from 'react'
import { WEEK_DAYS } from '../options'
import { theme } from '../../../../../../../Assets/Styles/theme'

const styles = {
  container: { display: 'flex', flexDirection: 'column', gap: 4 },
  weekRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  day: daySelected => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: daySelected ? theme.colors.primary : '#F8F8F8',
    borderRight: `1px solid white`,
    cursor: 'pointer',
    width: '100%',
    padding: '4px 10px',
  }),
  dayLabel: daySelected => ({
    color: daySelected ? 'white' : '#707087',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '18px',
  }),
  errorText: { color: 'red', fontSize: 12 },
}

const DaySelector = ({ daysSchedule, onDayPress, validationError }) => {
  return (
    <div style={styles.container}>
      <div style={styles.weekRow}>
        {WEEK_DAYS.map(weekDay => {
          const daySelected = daysSchedule.find(
            ({ day }) => day === weekDay.value,
          )
          return (
            <div
              key={weekDay.value}
              style={styles.day(!!daySelected)}
              onClick={() => onDayPress(weekDay.value)}
            >
              <div style={styles.dayLabel(!!daySelected)}>{weekDay.label}</div>
            </div>
          )
        })}
      </div>
      {validationError && <div style={styles.errorText}>{validationError}</div>}
    </div>
  )
}

export default DaySelector
